import service from '@/service';

// 权限-分页查询
export const getRolePage = (params: GetRolePageParams) =>
  service.get<BackendDataWithPage<RoleMana>>('/edu/mana/role/page', params);

// 树结构查询
export const getPermissionTree = () =>
  service.get<PermissionTree[]>('/edu/mana/permission/tree');

// 详情
export const getRoleDetail = (id: ID) =>
  service.get<RoleSub>(`/edu/mana/role/detail/${id}`);

// 新增/修改
export const oprRole = (params: RoleSub) =>
  service.putJSON<boolean>('/edu/mana/role', params);

// 删除
export const delRole = (id: number) =>
  service.del<boolean>(`/edu/mana/role/${id}`);

// 人员清单-分页查询
export const getRoleMemberPage = (params: GetRoleMemberParams) =>
  service.get<BackendDataWithPage<RoleMember>>('/edu/mana/role/user/page', params);

// 人员清单-添加
export const oprRoleMember = (params: RoleMemberOprQuery) =>
  service.postJSON<boolean>('/edu/mana/role/user', params);

// 人员清单-删除
export const delRoleMember = (id: number) =>
  service.del<boolean>(`/edu/mana/role/user/${id}`);

// 报告设置-考试权限-人员清单
export const getPerUserList = (examId: ID) =>
  service.get<PermissionUser[]>('/edu/mana/exam/permission/user/list', {examId});
